
import Vue from 'vue';
import numeral from 'numeral';
import numeralDe from 'numeral/locales/de';

const currencyConfig = {
	BGN: {
		wholeSymbol: 'лв',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	HRK: {
		wholeSymbol: 'kn',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	CZK: {
		wholeSymbol: 'Kč',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	DKK: {
		wholeSymbol: 'kr',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	EUR: {
		wholeSymbol: '€',
		wholePosition: 'before',
		thousands: ',',
		decimals: '.'
	},
	HUF: {
		wholeSymbol: 'Ft',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	NOK: {
		wholeSymbol: 'kr',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	PLN: {
		wholeSymbol: 'zł',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	RUB: {
		wholeSymbol: '₽',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	CHF: {
		wholeSymbol: 'Fr',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	RON: {
		wholeSymbol: 'lei',
		wholePosition: 'after',
		thousands: ',',
		decimals: '.'
	},
	GBP: {
		wholeSymbol: '£',
		wholePosition: 'before',
		thousands: ',',
		decimals: '.'
	}
};

Vue.filter('priceformat', function(value, currency){
	value = Number(value);

	if (!(currency) in currencyConfig){
		return numeral(value).format("0.00");
	}

	const settings = currencyConfig[currency];

	// 0,0.00 - output 1 115,00
	// 0.00 - output 1115,00
	numeral.locale('de');
	const outputValue = numeral(value).format("0.00");

	if (settings.wholePosition == 'before'){
		return settings.wholeSymbol + outputValue;
	}
	else{
		return outputValue + ' ' + settings.wholeSymbol;
	}
});

Vue.filter('currencySymbol', function(currency){
	if (!(currency) in currencyConfig){
		return currency;
	}

	const settings = currencyConfig[currency];

	return settings.wholeSymbol;
});